export const Curses = [
  ['Curse of Darkness', 'Curse of Darkness'],
  ['Curse of the Labyrinth', 'Curse of the Labyrinth'],
  ['Curse of the Lost', 'Curse of the Lost'],
  ['Curse of the Unknown', 'Curse of the Unknown'],
  ['Curse of the Cursed', 'Curse of the Cursed'],
  ['Curse of the Maze', 'Curse of the Maze'],
  ['Curse of the Blind', 'Curse of the Blind'],
  ['Curse of the Giant (Repentance)', 'Curse of the Giant'],
  ['Curse of the Imp (Fiend Folio)', 'Curse of the Imp'],
  ['Curse of the Stone (Fiend Folio)', 'Curse of the Stone'],
  ['Curse of the Sun (Fiend Folio)', 'Curse of the Sun'],
  ['Curse of the Swine (Fiend Folio)', 'Curse of the Swine'],
  ['Curse of the Ghost (Fiend Folio)', 'Curse of the Ghost'],
  ['Curse of the Scythe (Fiend Folio)', 'Curse of the Scythe'],
  ['Curse of the Master (Fiend Folio)', 'Curse of the Master'],
];
